import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHEstablecimientoEstructuraIns = async (credentials, data) => {
  const body = {
    service: "RNHEstablecimientoEstructuraIns",
    params: {
      rnhEstablecimientoEstructuraHospitalId: data?.rnhEstablecimientoId || '',
      rnhEstablecimientoEstructuraDireccionId: data?.rnhDireccionId || null,
      rnhEstablecimientoEstructuraDepartamentoId: data?.rnhDepartamentoId || null,
      rnhEstablecimientoEstructuraDivisionId: data?.rnhDivisionId || null,
      rnhEstablecimientoEstructuraServicioId: data?.rnhServicioId || null,
      rnhEstablecimientoEstructuraUnidadId: data?.rnhUnidadId || null,
      rnhEstablecimientoEstructuraCapsId: data?.rnhCapsId || null,
      rnhEstablecimientoEstructuraPuestoId: data?.rnhPuestoId || null,
      rnhEstablecimientoEstructuraPostaId: data?.rnhPostaId || null,
      rnhEstablecimientoEstructuraURESAId: data?.rnhUresaId || null,
    },
  };

  return respuestaDe(await axiosPost(body, credentials));
};
